"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var _ = require("lodash");
var theme = require("./theme.scss");
var utils_1 = require("./utils");
var LevelWrapper = function (_a) {
    var children = _a.children;
    return React.createElement("div", { className: theme.levelWrapper }, children);
};
var HistoryLogDiffItem = /** @class */ (function (_super) {
    tslib_1.__extends(HistoryLogDiffItem, _super);
    function HistoryLogDiffItem(props, context) {
        return _super.call(this, props, context) || this;
    }
    HistoryLogDiffItem.prototype.renderPropChange = function () {
        var _a = this.props, itemKey = _a.itemKey, data = _a.data;
        return (React.createElement(LevelWrapper, null,
            React.createElement("span", { className: theme.prop }, itemKey),
            " changed from ",
            utils_1.renderValueSnapshot(data.before),
            " to ",
            utils_1.renderValueSnapshot(data.after)));
    };
    HistoryLogDiffItem.prototype.renderArrayItem = function (item, index, isLast) {
        if (typeof item !== "object") {
            return React.createElement("span", { className: theme.value, key: index },
                item,
                !isLast ? ", " : "");
        }
        else {
            return React.createElement("span", { className: theme.value, key: index },
                utils_1.renderValueSnapshot(item),
                !isLast ? ", " : "");
        }
    };
    HistoryLogDiffItem.prototype.renderAddedArrayItems = function (items) {
        var _this = this;
        return (React.createElement(LevelWrapper, null,
            "Added items:",
            React.createElement("div", null, items.map(function (item, i) { return _this.renderArrayItem(item, i, i === items.length - 1); }))));
    };
    HistoryLogDiffItem.prototype.renderRemovedArrayItems = function (items) {
        var _this = this;
        return (React.createElement(LevelWrapper, null,
            "Removed items:",
            React.createElement("div", null, items.map(function (item, i) { return _this.renderArrayItem(item, i, i === items.length - 1); }))));
    };
    HistoryLogDiffItem.prototype.renderArrayChange = function () {
        var _a = this.props, itemKey = _a.itemKey, data = _a.data;
        return (React.createElement(LevelWrapper, null,
            React.createElement("span", { className: theme.prop }, itemKey),
            " list elements changed",
            data.add && data.add.length ? this.renderAddedArrayItems(data.add) : null,
            data.remove && data.remove.length ? this.renderRemovedArrayItems(data.remove) : null));
    };
    HistoryLogDiffItem.prototype.renderArrayItemsRecursive = function () {
        var _a = this.props, itemKey = _a.itemKey, data = _a.data;
        var properties = _(data).omit(["type", "add", "remove"]).value();
        if (_.keys(properties).length === 0) {
            return null;
        }
        return (React.createElement(LevelWrapper, null,
            React.createElement("span", { className: theme.prop }, itemKey),
            " properties changed",
            _(properties).map(function (d, key) { return React.createElement(HistoryLogDiffItem, { key: key, itemKey: key, data: d }); }).value()));
    };
    HistoryLogDiffItem.prototype.render = function () {
        var _a = this.props, itemKey = _a.itemKey, data = _a.data;
        if (typeof (data.before) !== "undefined" && typeof (data.after) !== "undefined") {
            return this.renderPropChange();
        }
        return (React.createElement(React.Fragment, null,
            data.type === "array" && (data.add || data.remove) ? this.renderArrayChange() : null,
            this.renderArrayItemsRecursive()));
    };
    HistoryLogDiffItem.defaultProps = {};
    return HistoryLogDiffItem;
}(React.Component));
exports.default = HistoryLogDiffItem;
